import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import slick from 'slick-carousel';



//custom code
var slideCount = $('.gallery-slider-count');
var slickSlide = $('.gallery-slider');

slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $(this).find('.gallery-slider-count').html('<span class="slideCountItem">' + i + '</span> ' + '/' + ' <span class="slideCountAll">' + slick.slideCount + '</span>');
});

slickSlide.slick({
	slideToShow: 1,
	fade: false,
	arrows:true,
	rows:0,
	prevArrow:'<button type="button" class="slide-btn slide-btn-prev"><i class="icon-angle-left"></i></button>',
	nextArrow:'<button type="button" class="slide-btn slide-btn-next"><i class="icon-angle-right"></i></button>',
});